import React from 'react'

const Band_Builder = () => {
  return (
    <iframe scrolling="yes" width="100%" height="2200px" frameborder="0" sandbox="allow-scripts allow-forms allow-same-origin" src="https://morgantaylor-frame-categoryembed.jewelershowcase.com/band-builder"></iframe>
  )
}

export default Band_Builder
